import React from 'react'

const MapPointAdd = props => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6673 0.833008V3.33301H19.1673V4.99967H16.6673V7.49967H15.0007V4.99967H12.5007V3.33301H15.0007V0.833008H16.6673ZM10.0007 10.833C9.08398 10.833 8.33398 10.083 8.33398 9.16634C8.33398 8.24967 9.08398 7.49967 10.0007 7.49967C10.9173 7.49967 11.6673 8.24967 11.6673 9.16634C11.6673 10.083 10.9173 10.833 10.0007 10.833ZM10.834 2.54967V4.23301C10.5583 4.18945 10.2797 4.16716 10.0007 4.16634C7.20898 4.16634 5.00065 6.30801 5.00065 9.33301C5.00065 11.283 6.62565 13.8663 10.0007 16.9497C13.3757 13.8663 15.0007 11.2913 15.0007 9.33301V9.16634H16.6673V9.33301C16.6673 12.0997 14.4423 15.3747 10.0007 19.1663C5.55898 15.3747 3.33398 12.0997 3.33398 9.33301C3.33398 5.18301 6.50065 2.49967 10.0007 2.49967C10.284 2.49967 10.559 2.51634 10.834 2.54967Z"
      fill="black"
      fill-opacity="0.56"
    />
  </svg>
)

export default MapPointAdd
